const OPTGROUPS = {
  transaction: '-- Transaction',
  account: '-- Buyer',
};

const FILTERS = [
  {
    id: 'app.id',
    label: 'Platform',
    optgroup: 'app',
    input: 'select',
    values: {
      'com.gasbuddymobile.gasbuddy': 'iOS Consumer Mobile',
      'gbis.gbandroid': 'Android Consumer Mobile',
    },
    operators: ['equal', 'not_equal'],
  },
];

const REQUESTS = [
];

export default {
  REQUESTS,
  FILTERS,
  OPTGROUPS,
};
